export default {
  props: {
    app: Boolean
  },

  created: function created() {
    this.updateApplication();
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/mixins/applicationable.js
// module id = gzFi
// module chunks = 0